/* eslint-disable no-unused-vars */
import CardWithTitle from 'components/CardWithTitle';
import React, { useState } from 'react';
import { Row } from 'reactstrap';
import { BID_STATUS } from 'utils/constants';
import Bids from './components/Bids';
import Summary from './components/Summary';

const BiddingDetails = ({ row, data, buttonDisabled, bidType }) => {
  const [rowIndex, setRowIndex] = useState(row.index);
  const currentRow = buttonDisabled ? row : data[rowIndex];
  const handlePrevNext = (e, step) => {
    if (step === 'next') {
      setRowIndex(rowIndex + 1);
    } else {
      setRowIndex(rowIndex - 1);
    }
  };
  const [activeTab, setActiveTab] = useState('');

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  return (
    <div>
      <CardWithTitle title="">
        <Row>
          {currentRow && (
            <Summary
              {...currentRow}
              index={rowIndex}
              handlePrevNext={handlePrevNext}
              max={data.length}
              buttonDisabled={!buttonDisabled}
            />
          )}
        </Row>
      </CardWithTitle>
      <CardWithTitle title="Active Bids">
        <Row>
          <Bids
            id={currentRow?.id}
            status={BID_STATUS.IN_PROGRESS}
            bidType={bidType}
          />
        </Row>
      </CardWithTitle>
      <CardWithTitle title="Expired Bids">
        <Row>
          <Bids
            id={currentRow?.id}
            status={BID_STATUS.EXPIRED}
            bidType={bidType}
          />
        </Row>
      </CardWithTitle>
    </div>
  );
};

export default BiddingDetails;
